// extracted by mini-css-extract-plugin
export var actions = "_sc-4";
export var item = "_sc-1";
export var price = "_sc-3";
export var quantity = "_sc-2";
export var table = "_sc-0";